import { PrimaryButton } from "components/Button/style";
import { FaSearch } from "react-icons/fa";
import styled from "styled-components";

export const Header = styled.h2`
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: space-between;
`;

export const TextoHeader = styled.span`
  color: ${({ theme }) => theme.colors.neutral.neutral90};
  font-weight: bold;
  font-size: 1.2rem;
  padding-top: 6px;
`;

export const Container = styled.div`
  margin-top: 2.5rem;
  width: 100%;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const Button = styled(PrimaryButton)`
  width: 170px;
  padding: 0.5rem 1rem;
  font-size: 12px !important;
`;

export const DivAcoes = styled.div`
  position: absolute;
  right: 35px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 16px;
`;

export const ContainerInputPesquisa = styled.div`
  display: flex;
  justify-content: end;
  margin-bottom: 16px;
  margin-top: 16px;
`;

export const InputWrapper = styled.div`
  position: relative;
  width: 178px;
`;

export const InputPesquisa = styled.input`
  width: 100%;
  padding-left: 30px; /* espaço para o ícone */
  padding-right: 10px;
  height: 36px;
  border: 1px solid #ccc;
  border-radius: 4px;

  &:focus {
    outline: none;
    border-color: #ccc;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
`;

export const Icon = styled(FaSearch)`
  position: absolute;
  top: 50%;
  left: 8px;
  transform: translateY(-50%);
  color: #999;
  pointer-events: none;
  width: 12px;
`;

export const ContainerValorTotal = styled.div`
  padding: 7px 0;
  font-size: 16px;
`;

